import React from 'react';
import {Link} from 'react-router-dom';
import AurAdhocSearchTextArea from '../../../common/aur-adhoc-search/AurAdhocSearchTextArea';
import {t} from 'i18next';

const AdhocSearch: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>
          {t('indexSearchPage.aurAdhocSearchControl.adHocSearchComponent')}
        </h1>
        $<div></div>
        <Link to="/demo">
          {t('indexSearchPage.aurAdhocSearchControl.return')}
        </Link>
        <hr />
        <div
          style={{
            marginBottom: '32px',
            width: '100%',
          }}
        >
          <AurAdhocSearchTextArea
            hasSearchesPerm={true}
            onClickRunSearch={() => {
              console.log('clicked run search');
            }}
            onClickClearAllButton={() => {
              console.log('clicked all clear');
            }}
            runDisabled={false}
            clearAllDisabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default AdhocSearch;
